/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Group, Link, Form, Grid, GridSet, GridItem, Icon, ToolTip, SelectField, TextField } from '@insticator/insticator-ui'; // iui-material
import Upload from 'material/ctas/upload/upload_container';
//styles
import styles from 'pages/dashboard/account/paymentinfo/selectmethod/wiretransfer/wiretransfer_styles';
import injectSheet from 'react-jss';



/* ========== ~~~~~~~~~~ WIRE TRANSFER ~~~~~~~~~~ ========== */
class WireTransfer extends Component {
    constructor(props){
        super(props);
        this.formName = 'WIRE';
    }

    componentWillMount(){
        if(this.props.paymentUUID)this.props.getWireTransferInformation(false, this.formName, this.props.paymentUUID);
    };

    handleFileUpload = (file) => {
        this.props.uploadFile(file, this.formName)
        this.props.handleFileUpload(file)
    };

    handleFileDiscard = () =>{
        this.props.discardFile(this.formName);
        this.props.handleFileDiscard()
    };

    businessType = () =>this.props.fields.businessType.value === `INTERNATIONAL_CORPORATION`;
    renderDownloadExistingOrGenericFormName = () => {
        return `Download ${this.props.fields.form.value.formLink ? 'your' : ''} ${this.businessType() ? `W-8BEN-E Form` : `W-8BEN Form`}`
    };
    renderDownloadExistingOrGenericFormLink = () => {
        return this.props.fields.form.value.formLink ? this.props.fields.form.value.formLink : this.businessType() ? `https://www.irs.gov/pub/irs-pdf/fw8bene.pdf` : `https://www.irs.gov/pub/irs-pdf/fw8ben.pdf`
    };
    render() {
        const { businessType, bankName, accountName, bankAddress, bankCity, bankState, bankZip, bankCountry, swift, iban } = this.props.fields;
            //INTERNATIONAL_CORPORATION, INTERNATIONAL_VENDOR
        return(
         <Form formName={this.formName} editable={this.props.editable}>
            <Grid klass={`wiretransfer ${this.props.classes.wiretransfer}`}>
                    <GridSet align={`horizontal`}>
                        <GridItem type={`full`}>
                            <SelectField type={`select`} name={`businessType`} value={businessType.value} valid={businessType.valid} defaultValue={businessType.value} formName={this.formName} placeholder={``} label={`Business Type`} info={``} options={[
                                { name:'INTERNATIONAL_CORPORATION', value:'INTERNATIONAL_CORPORATION', text:'International Company' },
                                { name:'INTERNATIONAL_VENDOR', value:'INTERNATIONAL_VENDOR', text:'International Vendor' }]} />
                        </GridItem>
                    </GridSet>
                    <GridSet align={`horizontal`}>
                        <GridItem>
                             <TextField type={`text`} name={`bankName`} value={bankName.value} valid={bankName.valid} formName={this.formName} placeholder={`Bank name`} label={`Bank Name`} info={``} required />
                        </GridItem>
                        <GridItem>
                            <TextField type={`text`} name={`accountName`} value={accountName.value} valid={accountName.valid} formName={this.formName} placeholder={`Account name`} label={`Account Name`} info={``} required />
                        </GridItem>
                    </GridSet>
                    <GridSet align={`horizontal`}>
                        <GridItem type={`full`}>
                            <TextField type={`text`} name={`bankAddress`} value={bankAddress.value} valid={bankAddress.valid} formName={this.formName} placeholder={`Street address`} label={`Bank Street Address`} info={``} required />
                        </GridItem>
                    </GridSet>
                    <GridSet align={`horizontal`}>
                        <GridItem>
                            <TextField type={`text`} name={`bankCity`} value={bankCity.value} valid={bankCity.valid} formName={this.formName} placeholder={`City`} label={`Bank City`} info={``} required />
                        </GridItem>
                        <GridItem>
                            <TextField type={`text`} name={`bankState`} value={bankState.value} valid={bankState.valid} formName={this.formName} placeholder={`State`} label={`Bank State / Province`} info={``} required />
                        </GridItem>
                    </GridSet>
                    <GridSet align={`horizontal`}>
                        <GridItem>
                            <TextField type={`text`} name={`bankZip`} value={bankZip.value} valid={bankZip.valid} formName={this.formName} placeholder={`Zip/Postal code`} label={`Bank Zip Code`} info={``} required />
                        </GridItem>
                        <GridItem>
                            <TextField type={`text`} name={`bankCountry`} value={bankCountry.value} valid={bankCountry.valid} formName={this.formName} placeholder={`Bank Country`} label={`Bank Country`} info={``} required/>
                        </GridItem>
                    </GridSet>
                    <GridSet align={`horizontal`}>
                        <GridItem>
                            <TextField type={`text`} name={`swift`} value={swift.value} valid={swift.valid} formName={this.formName} placeholder={`SWIFT bank code`} label={`Swift`} info={``} required />
                        </GridItem>
                        <GridItem>
                            <TextField type={`text`} name={`iban`} value={iban.value} valid={iban.valid} formName={this.formName} placeholder={`Account number / IBAN`} label={`Account number / IBAN`} info={``} required />
                        </GridItem>
                    </GridSet>
                    <GridSet align={`horizontal`}>
                        <GridItem>
                            <Group name={`upload-form valid-${this.props.fields.form.valid}`} >
                                <span>{this.businessType() ? `W-8BEN-E Form` : `W-8BEN Form`} <ToolTip align={`right`} action={`click`} content={<p>Please make sure you are uploading a file in PDF format (we currently do not support other file formats).</p>}><Icon name={`exclamation-circle`} /></ToolTip></span>
                                <Upload fileName={this.props.fields.form.value.name} uploadDate={this.props.fields.form.value.updatedDate} accept={'application/pdf'} handleDiscard={this.handleFileDiscard} handleFileUpload={this.handleFileUpload} />
                                {/*this link will have to change based on this pages state from redux, if document is previously uploaded user will be able to download it*/}
                                <Link text={this.renderDownloadExistingOrGenericFormName()} color={`primary`} type={`external`} action={this.renderDownloadExistingOrGenericFormLink()} icon={`arrow-down`} iconRight/>
                            </Group>
                        </GridItem>
                    </GridSet>
                </Grid>
         </Form>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(WireTransfer);
